<td-wb-toggle [small]="true"
              [ngModel]="selection()"
              (ngModelChange)="onToggleChange($event)"
              [disabled]="disabled()"
              [toggleId]="toggleId()">
  <span class="td-wb-vh"
        translate="tdWb.dividends.holdingsDripReinvestToggle.LABEL"></span>
</td-wb-toggle>
